//@flow
import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {Grid, Hidden, makeStyles} from '@material-ui/core';
import {colors} from '../../../../../assets/styles/colors';
import CustomButton from '../../../../../elements/CustomButton/CustomButton';
import {CheckCircle, RadioButtonUnchecked} from '@material-ui/icons';
import {usePrevious} from '../../../../../utils/react';
import {useIsFeatureInTier} from '../../../../../utils/component';

import fonts1 from '../../../../../assets/img/templates/fonts-1.svg';
import fonts2 from '../../../../../assets/img/templates/fonts-3.svg';
import fonts3 from '../../../../../assets/img/templates/fonts-2.svg';
import fonts4 from '../../../../../assets/img/templates/fonts-4.svg';
import fonts5 from '../../../../../assets/img/templates/fonts-5.svg';
import fonts6 from '../../../../../assets/img/templates/fonts-6.svg';
import fonts7 from '../../../../../assets/img/templates/fonts-7.svg';
import fonts8 from '../../../../../assets/img/templates/fonts-8.svg';
import fonts9 from '../../../../../assets/img/templates/fonts-9.svg';

import fonts1Mobile from '../../../../../assets/img/templates/fonts-1-mobile.svg';
import fonts2Mobile from '../../../../../assets/img/templates/fonts-2-mobile.svg';
//  import fonts3Mobile from '../../../../../assets/img/templates/fonts-3-mobile.svg';
import fonts4Mobile from '../../../../../assets/img/templates/fonts-4-mobile.svg';
import fonts5Mobile from '../../../../../assets/img/templates/fonts-5-mobile.svg';
import fonts6Mobile from '../../../../../assets/img/templates/fonts-6-mobile.svg';
import fonts7Mobile from '../../../../../assets/img/templates/fonts-7-mobile.svg';
import fonts8Mobile from '../../../../../assets/img/templates/fonts-8-mobile.svg';
import fonts9Mobile from '../../../../../assets/img/templates/fonts-9-mobile.svg';
import RestrictionModal from '../RestricionModal/RestrictionModal';

const useStyles = makeStyles(theme => ({
  buttonSquare: {
    width: '100%',
    height: '100%',
    '& span': {
      height: '100%',
    },
    border: '1px solid #E8E8ED',
    borderRadius: '8px',
    padding: 0,
  },
  skeletonSquare: {
    width: '100%',
    position: 'relative',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '8px',
    padding: theme.spacing(4, 2),
    [theme.breakpoints.down('md')]: {
      borderWidth: '1px',
    },
  },
  containerCheckedBox: {
    position: 'absolute',
    top: theme.spacing(2),
    left: theme.spacing(2),
  },
  wrapSlider: {
    width: '100%',
  },
  slider: {
    display: 'flex',
    gap: theme.spacing(2),
    overflowX: 'hidden',
    scrollBehavior: 'smooth',
    scrollSnapType: 'x mandatory',
  },
  itemSlider: {
    width: '100%',
    display: 'flex',
    flexShrink: '0',
    justifyContent: 'center',
    alignItems: 'center',
    transform0rigin: 'center center',
    transform: 'scale(1)',
  },
  containerDots: {
    margin: theme.spacing(2, 0),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  dot: {
    width: '0.8rem',
    height: '0.8rem',
    borderRadius: '50%',
    backgroundColor: colors.grey300,
  },
  dotSelected: {
    backgroundColor: colors.grey500,
  },
  btnDot: {
    width: 'fit-content',
    '& .MuiButton-label': {
      width: 'fit-content',
    },
  },
  imgFonts: {
    maxWidth: '100%',
    marginTop: theme.spacing(3),
  },
  skeletonSquareMobileSelected: {
    border: '1px solid #7B39FF',
  },
}));

type Props = {
  fontsSelected?: number,
  setFontsSelected: (id: number) => void,
};

export const FONTS_OPTIONS = [
  {
    src: fonts1,
    srcMobile: fonts1Mobile,
    id: 'fonts-1',
    primaryFontTypeId: 'FT-EA74954D',
    secondaryFontTypeId: 'FT-5B34BE4A',
  },
  {
    src: fonts2,
    srcMobile: fonts2Mobile,
    id: 'fonts-2',
    primaryFontTypeId: 'FT-8D94534B',
    secondaryFontTypeId: 'FT-A749554D',
  },
  {
    src: fonts3,
    id: 'fonts-3',
    // srcMobile: fonts3Mobile,
    primaryFontTypeId: 'FT-95A4E946',
    secondaryFontTypeId: 'FT-3B42734A',
  },
  {
    src: fonts4,
    id: 'fonts-4',
    srcMobile: fonts4Mobile,
    primaryFontTypeId: 'FT-8E94A343',
    secondaryFontTypeId: 'FT-5A4E5946',
  },
  {
    src: fonts5,
    id: 'fonts-5',
    srcMobile: fonts5Mobile,
    primaryFontTypeId: 'FT-EB746B42',
    secondaryFontTypeId: 'FT-5B34BE4A',
  },
  {
    src: fonts6,
    id: 'fonts-6',
    srcMobile: fonts6Mobile,
    primaryFontTypeId: 'FT-8B248A49',
    secondaryFontTypeId: 'FT-D945734B',
  },
  {
    src: fonts7,
    id: 'fonts-7',
    srcMobile: fonts7Mobile,
    primaryFontTypeId: 'FT-B8743B49',
    secondaryFontTypeId: 'FT-E94AB343',
  },
  {
    src: fonts8,
    id: 'fonts-8',
    srcMobile: fonts8Mobile,
    primaryFontTypeId: 'FT-2874DA4D',
    secondaryFontTypeId: 'FT-B7463B42',
  },
  {
    src: fonts9,
    id: 'fonts-9',
    srcMobile: fonts9Mobile,
    primaryFontTypeId: 'FT-E5747E48',
    secondaryFontTypeId: 'FT-B2487A49',
  },
];

export default function FontsSection(props: Props) {
  const {fontsSelected, setFontsSelected} = props;
  const prevFontsSelected = usePrevious(fontsSelected);
  const classes = useStyles();

  const hasCustomFontFeature = useIsFeatureInTier('FONT_CONFIGURATION');

  const [currentSlider, setCurrentSlider] = useState(0);

  useEffect(() => {
    if (!prevFontsSelected && typeof fontsSelected === 'number') {
      const r = Math.floor(fontsSelected / 2);
      setCurrentSlider(r);
    }
  }, [fontsSelected, prevFontsSelected]);

  const handleViewSlider = (id: number) => {
    setCurrentSlider(id);
  };
  const checkedCheckbox = (
    <CheckCircle color="primary" style={{fontSize: '1.75rem'}} />
  );
  const uncheckedCheckbox = (
    <RadioButtonUnchecked style={{color: '#D4D4DD', fontSize: '1.75rem'}} />
  );

  const fontsContent = FONTS_OPTIONS.map((to, idx) => (
    <Grid key={to.id} item xs={6}>
      <CustomButton
        className={classes.buttonSquare}
        onClick={() => setFontsSelected(idx)}
      >
        <div
          className={`${classes.skeletonSquare} ${
            fontsSelected === idx ? classes.skeletonSquareMobileSelected : ''
          }`}
        >
          <div className={classes.containerCheckedBox}>
            {fontsSelected === idx ? checkedCheckbox : uncheckedCheckbox}
          </div>
          <img
            src={to.srcMobile ? to.srcMobile : to.src}
            alt={'fonts' + idx}
            className={classes.imgFonts}
          />
        </div>
      </CustomButton>
    </Grid>
  ));

  const currentColorContent = (idx: number) => {
    const idxLeft = idx * 2;
    const idxRight = (idx + 1) * 2;
    return (
      <div className={classes.wrapOptionsColor}>
        <Grid container spacing={1}>
          {fontsContent.slice(idxLeft, idxRight)}
        </Grid>
      </div>
    );
  };

  return (
    <div style={{position: 'relative'}}>
      {!hasCustomFontFeature && <RestrictionModal featureLabel="Tipografías" />}
      <Hidden xsDown>
        <Grid container spacing={1}>
          {FONTS_OPTIONS.map((to, idx) => (
            <Grid key={to.id} item xs={12} sm={6} lg={4}>
              <CustomButton
                className={classes.buttonSquare}
                onClick={() => setFontsSelected(idx)}
              >
                <div className={classes.skeletonSquare}>
                  <div className={classes.containerCheckedBox}>
                    {fontsSelected === idx
                      ? checkedCheckbox
                      : uncheckedCheckbox}
                  </div>
                  <img
                    src={to.src}
                    alt={'fonts' + idx}
                    className={classes.imgFonts}
                  />
                </div>
              </CustomButton>
            </Grid>
          ))}
        </Grid>
      </Hidden>
      <Hidden smUp>
        {currentColorContent(currentSlider)}
        <div className={classes.containerDots}>
          <div className={classes.dots}>
            {[0, 1, 2, 3, 4].map((to, idx) => (
              <CustomButton
                key={idx}
                className={classes.btnDot}
                onClick={() => handleViewSlider(idx)}
              >
                <div
                  className={`${classes.dot} ${
                    currentSlider === idx ? classes.dotSelected : ''
                  }`}
                />
              </CustomButton>
            ))}
          </div>
        </div>
      </Hidden>
    </div>
  );
}

FontsSection.propTypes = {
  fontsSelected: PropTypes.number,
  setFontsSelected: PropTypes.func.isRequired,
};
